export default __webpack_public_path__ + "static/media/PPI-steps-014.23adc5ab.jpg";